import angular from 'angular';

import { HomeComponent } from './home.component';

const home = angular.module('home', ['ui.router', 'commons', 'auth']);

home.component('home', HomeComponent);

export const HomeModule = home;